import React, { useState } from "react";
import RegistrationForm from "./RegistrationForm";
import RegistrationSuccess from "./RegistrationSuccess";

const Registration = () => {
  const [successRegistration, setSuccessRegistration] = useState(false);
  const [userDetails, setUserDetails] = useState({ username: "", email: "" });

  if (!successRegistration) {
    return <RegistrationForm setSuccessRegistration={setSuccessRegistration} setUserDetails={setUserDetails} />;
  } else {
    return <RegistrationSuccess userDetails={userDetails} />;
  }
};

export default Registration;
